
import {OnboardingTellUsAboutYourself} from "./onboarding-tell-us-about-yourself.model";
import {CustomerInfo} from "./customer-info";
import {ApplicantType} from "./applicant-type";
import {OnboardingEmployment} from "./onboarding-employment.model";

export class OnboardingApplicant {

  applicantType?: ApplicantType;
  tabLabel : string;
  cif?: string;
  username?: string;
  nickname?: string;
  applicantId : number;
  isMinor? : boolean;

  tellUsAboutYourself : OnboardingTellUsAboutYourself;
  tellUsAboutYourselfOriginal: OnboardingTellUsAboutYourself;

  employmentDetails : OnboardingEmployment;
  employmentDetailsOriginal : OnboardingEmployment;
  customerInfo: CustomerInfo = {
    checkSucceeded: false
  };

  constructor() {
    this.tabLabel = "";

    this.applicantId = 0;

    this.tellUsAboutYourself = new OnboardingTellUsAboutYourself();
    this.tellUsAboutYourselfOriginal = new OnboardingTellUsAboutYourself();

    this.employmentDetails = new OnboardingEmployment();
    this.employmentDetailsOriginal = new OnboardingEmployment();

    this.employmentDetails = new OnboardingEmployment();
  }
}

